/** @jsx jsx */

import { jsx, Heading, Paragraph, Flex } from "theme-ui"

import theme from "../gatsby-plugin-theme-ui"
import Deer from "../images/home-page-deer.inline.svg"

export const About = () => {
  return (
    <div id="about" sx={{ backgroundColor: "primary", py: 6 }}>
      <Flex
        sx={{
          ...theme.basePageStyles.contentContainer,
          flexDirection: ["column", "column", "row"],
          color: "white",
          alignItems: "center",
        }}
      >
        <Deer
          sx={{
            order: [1, 1, 0],
            height: "auto",
            maxWidth: ["80vw", "80vw", "50%"],
            maxHeight: "600px",
            mr: [0, 0, "60px"],
          }}
        />
        <div sx={{ flex: 1, p: { mb: 2 } }}>
          <Heading as="h1" sx={{ mb: 3 }}>
            What is this?
          </Heading>
          <Paragraph>
            I went to Japan. Silly stuff happened. I decided to make a comic.
            And then a website for that comic.
          </Paragraph>
          <Heading as="h1" sx={{ mt: 5, mb: 3 }}>
            Will there be more?
          </Heading>
          <Paragraph>Probably not.</Paragraph>
          <Paragraph>
            The comic currently stops at Nara, which also just about marks the
            point where I set off on my solo leg of the trip (give or take). So,
            a pretty natural ending point.
          </Paragraph>
          <Paragraph>
            Although I have drawn nothing explicitly about that leg of the trip,
            the spirit of that one week permeates this whole artistic project.
          </Paragraph>
        </div>
      </Flex>
    </div>
  )
}
